import { writeCredential } from './credentialsStorage';

/**
 * Sets multiple cookies with the specified key-value pairs.
 * @function setCookieValues
 * @param {Array<{ key: string, value: string }>} values - An array of objects containing key-value pairs for cookies.
 * Each object must have a `key` representing the cookie name and a `value` representing the cookie value.
 * @param {boolean} secure - Determines if the Secure flag should be added to the cookies.
 * @param {number} [expiresInDays] - Optional. The number of days until the cookies expire.
 *
 * Besides the cookie, every value is mirrored into `credentialsStorage`. Inside a
 * cross-site iframe (the embed within the producer's site) the browser silently drops
 * the cookie — the write below does not fail, it just does not persist. The mirror is
 * what keeps the credential alive in that scenario; where the cookie works, it remains
 * the source of truth on read. See credentialsStorage.ts.
 */
const setCookieValues = (
  values: { key: string; value: string }[],
  secure: boolean = false,
  expiresInDays = 1,
) => {
  values.forEach(({ key, value }) => {
    const secureFlag = secure ? '; Secure' : '';
    let expires = '';

    const date = new Date();
    date.setDate(date.getDate() + expiresInDays);
    expires = `; Expires=${date.toUTCString()}`;

    document.cookie = `${key}=${value}; domain=.ingresse.com; path=/${expires}${secureFlag}`;

    writeCredential(key, value);
  });
};

export default setCookieValues;
